import { render } from "./removeAccount.vue?vue&type=template&id=bd0f5d42&scoped=true"
import script from "./removeAccount.vue?vue&type=script&lang=js"
export * from "./removeAccount.vue?vue&type=script&lang=js"

import "./removeAccount.vue?vue&type=style&index=0&id=bd0f5d42&scoped=true&lang=css"

import exportComponent from "F:\\قبل النهائي\\nawaf\\nawaf\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd0f5d42"]])

export default __exports__